import useGetTranslationLoading from './useGetTranslationLoading'

export default useGetTranslationLoading
